import React, { Component, PropTypes } from 'react'
import Link from 'gatsby-link'

import './index.scss'

class Footer extends Component {
  render () {
    const { children } = this.props

    return (
      <div className="inner">
        <div className="meta-panel">
          <small>&copy; Natalie Johnson 2018.</small>
        </div>
      </div>
    )
  }
}

Footer.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js